import { NavItem, Select, SelectProps } from '@billy/design-system'
import { forwardRef, ReactElement, Ref, useMemo } from 'react'

import { zervantFontOptions } from './constants/zervantFontOptions'

type FontSelectProps = Omit<SelectProps<string>, 'items'>

export const FontSelect = forwardRef(
  (selectProps: FontSelectProps, forwardedRef: Ref<HTMLDivElement | null>): ReactElement => {
    const fontItems: NavItem<string>[] = useMemo(() => {
      return Object.entries(zervantFontOptions).map(([key, value]) => ({ id: key, children: value, value }))
    }, [])

    return <Select {...selectProps} items={fontItems} ref={forwardedRef} />
  },
)
